export const createStartOfDay = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setHours(0, 0, 0, 0);
  return newDate;
};

export const createEndOfDay = (date: Date): Date => {
  const newDate = new Date(date);
  newDate.setHours(23, 59, 59, 999);
  return newDate;
};

export const parseStartOfDay = (value: string): Date => {
  const [y, m, d] = value.split("-").map(Number);
  return new Date(y, m - 1, d, 0, 0, 0, 0);
};

export const parseEndOfDay = (value: string): Date => {
  const [y, m, d] = value.split("-").map(Number);
  return new Date(y, m - 1, d, 23, 59, 59, 999);
};

export const getToday = (): Date => new Date();

export const formatDateForInput = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const calculateRelativeDays = (
  days: number
): { start: Date; end: Date } => {
  const today = getToday();
  const end = createEndOfDay(today);
  const start = new Date(today);

  if (days === 0) {
    return { start: createStartOfDay(start), end };
  } else if (days === 1) {
    start.setDate(start.getDate() - 1);
    const yesterdayEnd = new Date(start);
    return {
      start: createStartOfDay(start),
      end: createEndOfDay(yesterdayEnd),
    };
  } else {
    start.setDate(start.getDate() - days);
    return { start, end };
  }
};

export const calculateThisMonth = (): { start: Date; end: Date } => {
  const today = getToday();
  const firstDayThisMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  return {
    start: createStartOfDay(firstDayThisMonth),
    end: createEndOfDay(today),
  };
};

export const calculateLastMonth = (): { start: Date; end: Date } => {
  const today = getToday();
  const firstDayLastMonth = new Date(
    today.getFullYear(),
    today.getMonth() - 1,
    1
  );
  const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);
  return {
    start: createStartOfDay(firstDayLastMonth),
    end: createEndOfDay(lastDayLastMonth),
  };
};
